import $ from 'jquery';

$(async function (_event) {
  const dsp = (global.dsp = global.dsp || {});
  const DEFAULT_CONTENT_LIFESPAN = 10 * 60 * 1000;
  const loadedContent = new Map();

  async function fetchHoverContent(key) {
    const localKey = `dsp_hover_content_${key}`;
    let content;
    let needsFetch = true;

    try {
      const storedContent = localStorage.getItem(localKey);
      if (typeof storedContent !== 'undefined') {
        const parsedContent = JSON.parse(storedContent) ?? {};
        content = parsedContent.content;
        if (parsedContent.expires && parsedContent.expires > Date.now()) {
          needsFetch = false;
        }
      }
    } catch (e) {
      // Local storage isn't working.
      // This is treated the same as the key being missing.
    }

    if (needsFetch === false) {
      return content;
    }

    // Fetch updated content.
    const contentPromise = new Promise((resolve, reject) => {
      $.get(themosis.ajaxurl, {
        action: 'dsp_hover_content',
        _ajax_nonce: dsp_hover_content.nonce,
        content_key: key,
      })
        .done((content, _status, _response) => {
          try {
            localStorage.setItem(
              localKey,
              JSON.stringify({
                expires: Date.now() + DEFAULT_CONTENT_LIFESPAN,
                content: content,
              }),
            );
          } catch (e) {
            // Local storage isn't working.
            // This can be ignored.
          }

          resolve(content);
        })
        .fail((response, _status, _error) => {
          console.error(response.responseJSON?.data?.[0] ?? `Error ${response.status}`);
          resolve(null);
        });
    });

    // Wait for the fetch if there was no cached version.
    if (typeof content === 'undefined') {
      return await contentPromise;
    }

    return content;
  }

  // Load known content from local cache.
  async function getHoverContent(key) {
    let content = loadedContent.get(key);

    if (typeof content === 'undefined') {
      content = fetchHoverContent(key);
      loadedContent.set(key, content);
    }

    return content;
  }

  const createPopup =
    dsp.dealerTools.get('dsp-hover-content-create') ??
    function ($trigger, data, $context) {
      const $container = $(
        `<div id="dsp-hover-content--${data.key}" class="dsp-hover-content-container dsp-hover-content-container_${data.key}">LOADING</div>`,
      );

      $container.hide();

      $trigger.after($container);

      data.contentPromise.then((content) => {
        $container.html(content);
        data.activateHoverContent($container);
      });

      $trigger.parent().on('mouseenter', () => {
        $container.show();
      });

      $trigger.parent().on('mouseleave', () => {
        $container.hide();
      });
    };

  function activateHoverContent($context) {
    const $triggers = $('[data-dsp-hover-content]', $context);
    if ($triggers.length === 0) {
      return;
    }

    $triggers.each(function () {
      const $trigger = $(this);
      const hoverKey = $trigger.data('dspHoverContent');

      // Start pre-loading updated hover content.
      const contentPromise = getHoverContent(hoverKey);

      createPopup(
        $trigger,
        {
          key: hoverKey,
          activateHoverContent,
          contentPromise,
        },
        $context,
      );
    });
  }

  activateHoverContent($(document.body));
});
